import { FeatureFeedback, Post } from '@app/support/models/post.model';

export const addRefToPost = (post: Post): Post => {
  if (post.mainImage?.asset?.ref) {
    return {
      ...post,
      mainImage: {
        ...post.mainImage,
        asset: {
          ...post.mainImage.asset,
          _ref: post.mainImage.asset.ref,
        },
      },
    };
  }
  return post;
};

export const addRefToFeatureFeedback = (featureFeedback: FeatureFeedback): FeatureFeedback => {
  if (featureFeedback.mainImage?.asset?.ref) {
    return {
      ...featureFeedback,
      mainImage: {
        ...featureFeedback.mainImage,
        asset: {
          ...featureFeedback.mainImage.asset,
          _ref: featureFeedback.mainImage.asset.ref,
        },
      },
    };
  }
  return featureFeedback;
};

export const alternateDistributionOfPosts = (posts: Post[]): Post[][] => {
  const result = posts.reduce(
    ([array1, array2], element, index) => {
      if (index % 2 === 0) {
        array1.push(element);
      } else {
        array2.push(element);
      }
      return [array1, array2];
    },
    [[], []]
  );
  if (result[0].length === 0 && result[1].length === 0) {
    return [];
  }
  return result;
};
